

function CustomersPage() {
  return <div>Customers Page</div>;
}

export default CustomersPage;
